const Data = {
  WebsiteTitle: "Serenade Festival | Event Production & Management Services",
  HeaderTitle: "Serenade Festival",
  FooterText: "© 2026 Serenade Festival. All rights reserved.",
  AboutEmail: "serenadefestival@gmail.com",
  AboutEmailSubject: "Inquiry about Serenade Festival",
  AboutHeading: "About Serenade Festival",
  AboutTextParagraph1:
    "Founded in 2019 by Hemanth YMS and co-founder Purundar YMR, Serenade Festival stands as one of India's most dynamic platforms celebrating the spirit of music, creativity, and performance. Emerging from its roots as a college-driven initiative, Serenade Festival has evolved into a nationwide movement, successfully producing over 35 shows across India, from vibrant club nights to grand outdoor arena experiences.",
  AboutTextParagraph2:
    "With expertise spanning artist management, production direction, stage and lighting design, marketing strategy, ticketing, music festivals, and curating, Serenade Festival ensures every project is executed with precision and passion. Its dedicated team transforms each event into an immersive experience that connects audiences, artists, and culture. Today, Serenade Festival continues to push boundaries in India's live entertainment scene, redefining how music festivals are imagined, produced, and celebrated.",
  AboutButtonText: "Get in Touch",
  Phone: "+91 8106668207",
  Instagram: "https://www.instagram.com/serenadefestival?igsh=bXhtZzljYzVzZHVi",
  Gmail: "serenadefestival@gmail.com",
  LinkedIn: "https://linkedin.com/company/serenadefestival",
  WhatsApp: "+91 8106668207",
  
  // Talent Section
  TalentList: [
    "ANFENER",
    "MARK",
    "SRUJITH",
    "TALAM"
  ],
  
  // Crew Section
  CrewMembers: [
    { title: "CEO & FOUNDER", name: "YMS HEMANTTH" },
    { title: "CO FOUNDER & MANAGING PARTNER", name: "YMR PURUNDAR" },
    { title: "CREATIVE DIRECTOR", name: "BASANTH V" },
    { title: "TOUR MANAGER", name: "MANIKANTH RATHOD" },
    { title: "PRODUCTION MANAGER", name: "DILIP REDDY" },
    { title: "CREATIVE HEAD", name: "SUSHANTH MAHARANA" },
    { title: "PHOTOGRAPHER", name: "AMOUR BY SAI KIRAN" }
  ]
};

export default Data;
